import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, mergeProps as _mergeProps, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "mt-6 error--text"
}
const _hoisted_2 = { class: "text-black" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_file_input = _resolveComponent("v-file-input")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.label)
      ? (_openBlock(), _createElementBlock("label", {
          key: 0,
          class: "input-label",
          style: _normalizeStyle({ paddingLeft: _ctx.prependIcon != '' ? '42px' : '0px' })
        }, [
          _createTextVNode(_toDisplayString(_ctx.label) + " ", 1),
          (_ctx.showRequired)
            ? (_openBlock(), _createElementBlock("small", _hoisted_1, "*"))
            : _createCommentVNode("", true)
        ], 4))
      : _createCommentVNode("", true),
    _createVNode(_component_v_file_input, _mergeProps({ class: "file-input-textbox" }, _ctx.$attrs, {
      "onUpdate:modelValue": _ctx.change,
      "prepend-icon": _ctx.prependIcon
    }), {
      selection: _withCtx(({ fileNames }) => [
        _createElementVNode("span", _hoisted_2, _toDisplayString(fileNames[0]), 1)
      ]),
      _: 1
    }, 16, ["onUpdate:modelValue", "prepend-icon"])
  ]))
}